import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Card, Icon, Col, Row, Select, DatePicker, Tag } from 'antd';
import { sanitizerTexto, getStatusInv, getStatusInvColor  } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import CatalogoRequest from '../../services/Catalogo';
import { get_id } from '../../util/IdUser';
import { ShowMenuItem } from '../../util/ShowMenuItem';
import InventarioRequest from '../../services/Inventario';
import ReporteRequest from '../../services/Reportes';
import moment from 'moment'
import 'moment/locale/es';
import { roles } from '../../util/Roles';
import dayjs from 'dayjs';
import { esBarras, getSegmento } from '../../util/generics';
moment.locale('es')
const rol = localStorage.getItem("role")?.split(",");
const { Option } = Select
const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';
const userId = localStorage.getItem("id_user");

/**
 * Clase para ver el proceso de calendario pedidos
 */
export default class FacturasVisualizador extends Component {
    state = {
        esBarra: esBarras(),
        arrCierreDia: [],
        filterText: "",
        cargando: false,
        bloquear_guardar: true,
        arrDrives: [],
        allDrives: [],
        drivesSelected: [],
        scroll: { x: 1250, y: 470 },
        disable_combo_drive: false,
        typeForm: null,
        paginacion: {},
        dateStrings: [],
        fecha_cierre_dia: [],
        disableRange: true,
        paginaSiguiente: 1,
        disableApplyFilters: true,
        filtros: {
            id_drives: undefined,
            dateStrings: undefined,
            page: undefined
        },
        firstDate:null,
    }

    /**
     * Comportamiento del componente al mostrar el historico de inventarios
     */
    componentDidMount = () => {
        let state = { ...this.state };
        const segmento = getSegmento()
        if (!segmento || esBarras()) {
            const location = {
                pathname: "/",
            }
            this.setState(state, this.props.history.push(location))
        } else{
            CatalogoRequest.CargarSitiosByUsuario(get_id()).then(response => {
                state.arrDrives = response.data
                state.allDrives = response.data.map(f => f.id);
                
                if(state.arrDrives.length){
                } else {
                    state.arrDrives.unshift({id: -1, plaza: 0, cr: 'No hay resultados', nombre: 'No hay resultados', plaza_nombre: 'No hay resultados', disable:true})
                }
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar los puntos de venta del usuario.",
                    "Error"
                )
            })
        }
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrEquivalenciasCopy = state.arrEquivalencias
        if (value) {
            arrEquivalenciasCopy = arrEquivalenciasCopy.filter(obj => {
                return sanitizerTexto(value, obj.articulo.codigo)
                    || sanitizerTexto(value, obj.articulo.descripcion)
            })
        }
        state.arrEquivalenciasCopy = arrEquivalenciasCopy
        this.setState(state);
    }

    /**
     * Se ejecuta cuando se busca en el input text
     */
    handleSearchInput = (text) => {
        let state = { ...this.state };
        state.filterText = text;
        this.setState(state);

        clearTimeout(state.timer)
        state.timer = setTimeout(() => {
            this.applyFilters();
        }, 1000);
    }

    filtrarBtn = (info) => {
        let state = { ...this.state };
        this.setState({ cargando: true }, () => {
            if (state.drivesSelected) {
                state.filtros.drive_id = state.drivesSelected;
                state.filtros.dateStrings = state.dateStrings;
                ReporteRequest.CierreDia(state.filtros).then(response => {
                    state.paginacion = {
                        current: 1,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 100,
                        showTitle: false
                    }
                    state.bloquear_guardar = false;
                    state.cargando = false;
                    state.arrCierreDia = response.data
                    state.disableRange = false;
                    this.setState(state)
                }).catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar el histórico del drive seleccionado.",
                        "Error"
                    )
                })
            } else {
                state.cargando = false;
                state.paginacion.total = 0;
                state.arrCierreDia = [];
                state.disableRange = false;
                state.dateStrings = [];
                state.fecha_cierre_dia = [];
                this.setState(state)
            }
        })
    }

    /**
     * Se ejecuta cuando hay un cambio en combo de drive
     */
    onChangeDrive = (value) => {
        let state = { ...this.state };
        if (value === undefined) {
            state.drivesSelected = [];
            state.disableApplyFilters = true;
            state.disableRange = true;
            state.dateStrings = [];
            state.fecha_cierre_dia = [];
        } else {
            state.drivesSelected = value
            state.disableRange = false;
        }
        state.arrCierreDia = [];

        this.setState(state)
    }

    /**
    * Función que se ejecuta cuando se cambia el rangepicker
    * @param: dates. valores  del rangepicker
    * @param: dateStrings. valores en formato string de la fecha
    * @return: nada
    */
    onChangeRange = (dates, dateStrings) => {
        let state = { ...this.state };
        state.dateStrings = dateStrings;
        state.fecha_cierre_dia = dates;
        state.arrCierreDia = [];
        if (!dates.length) {
            state.disableApplyFilters = true;
        } else {
            state.disableApplyFilters = false;
        }
        this.setState(state);
    }

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        state.paginaSiguiente = paginaSiguiente
        this.setState({ cargando: true }, () => {
            if (state.drivesSelected) {
                ReporteRequest.CierreDia(state.filtros, paginaSiguiente).then(response => {
                    state.paginacion = {
                        current: paginaSiguiente,
                    }
                    state.bloquear_guardar = false;
                    state.cargando = false;
                    state.arrCierreDia = response.data
                    state.disableRange = false;
                    this.setState(state)
                }).catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar el histórico del drive seleccionado.",
                        "Error"
                    )
                })
            }
        })
    }

    disabledFutureDates = (current) => {
        // Disable dates after today
        return current && current > dayjs().endOf('day');
    }

    render() {
        const columnasInventario = [
            {
                title: "Fecha Cierre",
                dataIndex: "fecha",
                key: "fecha",
                render: fecha => {
                    return ( <span> {moment(fecha).format("DD/MM/YYYY")} </span> )
                }
            },
            {
                title: "Timbrado SAT",
                dataIndex: "timbrado",
                key: "timbrado",
                render: value => {
                    return ( <span> {value} </span> )
                }
            },
            {
                title: "Enviado SAP",
                dataIndex: "enviadoSAP",
                key: "enviadoSAP",
                render: (value) => {
                    return ( <span> {value} </span> )
                }
            },
            {
                title: "Existencia Actualizada",
                dataIndex: "syncro",
                key: "syncro",
                render: value => {
                    return ( <span> {value} </span> )
                }
            }
        ]

        return (
            <Card id="ParentSize"
                title="Facturación"
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={[16]} >
                            <Col span={5}>
                                <Tooltip placement="top" title={this.state.esBarra ? "Seleccione una barra" : "Seleccione un Punto de venta"}>
                                    <div className="center">
                                        {
                                            this.state.esBarra ? "Barra:" : "Punto de venta:"
                                        }
                                    </div>
                                    <Select
                                        defaultActiveFirstOption={false}
                                        allowClear={this.state.arrDrives?.length > 1}
                                        showSearch
                                        disabled={this.state.disable_combo_drive}
                                        notFoundContent={"No hay opciones"}
                                        style={{ width: "100%" }}
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                        value={this.state.drivesSelected}
                                        onChange={this.onChangeDrive}
                                        //onChange={(value) => {
                                        //    this.setState({ driveSelected: value }, this.onChangeDrive)
                                        //}}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives?.length > 0 &&
                                            this.state.arrDrives.map((obj, index) => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={6}>
                                <Tooltip placement="top" title="Rango de fecha">
                                    <div className="center">Rango de fecha:</div>
                                    <RangePicker
                                        format={ dateFormat }
                                        placeholder={["Fecha inicial", "Fecha final"]}
                                        value={ this.state.fecha_cierre_dia }
                                        disabled={ this.state.disableRange }
                                        ranges={{
                                            'Última Semana': [moment().subtract(6, 'days').startOf('day'), moment()],
                                            'Último Mes': [moment().subtract(29, 'days').startOf('day'), moment()],
                                            'Último Año': [moment().subtract(365, 'days').startOf('day'), moment()]
                                        }}
                                        onOpenChange={(open)=>{
                                            if(open){
                                                this.setState({firstDate:null})
                                            }
                                        }}
                                        //disabledDate={d => d.isSameOrBefore(moment().subtract(730, 'days').startOf('day'))}
                                        disabledDate={(current)=>{
                                            let state = {...this.state}
                                            let firstDateClone = moment(JSON.parse(JSON.stringify(state.firstDate)));
                                            return state.firstDate ? state.firstDate > current || current > firstDateClone.add(31, 'day') :false;
                                        }}
                                        onChange={(dates, dateStrings) => {
                                            this.onChangeRange(dates, dateStrings);
                                        }}
                                        onCalendarChange={(dates,dateStrings,info)=>{
                                            const firstDate = dates[0];
                                            let firstDateClone = moment(JSON.parse(JSON.stringify(firstDate)));
                                            this.setState({firstDate:firstDate,fecha_cierre_dia:[firstDate,firstDateClone.add(31,'day')]});
                                        }}
                                    />
                                </Tooltip>
                            </Col>
                            {/* <Col span={8}>
                                <Tooltip placement="top" title="Timbrada">
                                    <div className="center">Timbrada:</div>
                                    <Select id="select-status-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        mode="multiple"
                                        onChange={this.handleChangeStatus}
                                        value={this.state.statusSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrStatus.length > 0 &&
                                            this.state.arrStatus.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.idStatus}
                                                        value={obj.idStatus}
                                                        disabled={obj.disable}>

                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col> */}
                            <Col span={2}>
                                <Tooltip placement="top" title={this.state.drivesSelected.length ? "Realizar búsqueda" : ""}>
                                    <Button
                                        id="boton-filtrar-productos-filtros"
                                        className={this.state.disableApplyFilters ? "disableBtn" : ""}
                                        type={this.state.disableApplyFilters ? "default" : "primary"}
                                        icon="search"
                                        style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.7em' }}
                                        onClick={() => {
                                            this.setState({ paginaSiguiente: 1 }, this.filtrarBtn)
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            columns={columnasInventario}
                            dataSource={this.state.arrCierreDia}
                            pagination={this.state.paginacion}
                            scroll={{ y: 600 }}
                        />
                    </Spin>
                </div>
            </Card>
        )
    }
}